const alphabetize = <T>(rawArray: Array<T>, sortBy?: keyof T): Array<T> => {
    if (sortBy) {
        return rawArray.slice().sort((a, b) => {
            if (a[sortBy] < b[sortBy]) {
                return -1;
            }
            if (a[sortBy] > b[sortBy]) {
                return 1;
            }
            return 0;
        });
    } else {
        return rawArray.slice().sort((a, b) => {
            if (a < b) {
                return -1;
            }
            if (a > b) {
                return 1;
            }
            return 0;
        });
    }
};

export { alphabetize };
